import { app } from '@/main';
import TicketRequest from '@/views/Admin/TicketRequest/TicketRequest.vue';
import { Route } from '../route.model';
import { SuperAdminPermission } from '@/models/super-admin';

const validateRouteFlag = () => {
  const permissions = app.$store.getters['manager/getPermissions'];

  return [
    SuperAdminPermission.TicketUpdate,
    SuperAdminPermission.TicketCreate
  ].some(permission => permissions.includes(permission));
};

const adminTicketRequest = new Route(
  '/admin/ticket-request',
  'ticket-request',
  TicketRequest,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Tickets',
      icon: 'customer-center'
    },
    customFlagValidator: validateRouteFlag,
    zendesk: {
      disabled: true
    }
  }
);

export { adminTicketRequest };
export default adminTicketRequest;
